// Values must match DocumentStatusDto.id (backend documentProcessStatus codes).
export enum DocumentProcessStatusCode {
  RedlineMarkup = 1,
  ForInfo = 5,
  NoChange = 9,
}

// Translation key for each status code's name - used only as a parenthetical translation next to
// the raw MIPS status name (e.g. in the status dialog), never as the primary label.
export const DOCUMENT_PROCESS_STATUS_LABEL_KEYS: Record<number, string> = {
  [DocumentProcessStatusCode.RedlineMarkup]: 'workOrderDocuments.status.redlineMarkup',
  [DocumentProcessStatusCode.ForInfo]: 'workOrderDocuments.status.forInfo',
  [DocumentProcessStatusCode.NoChange]: 'workOrderDocuments.status.noChange',
};

// "Status: {{id}} ({{name}})" - id/name are the raw MIPS code/name, left untranslated.
export const DOCUMENT_PROCESS_STATUS_LABEL_KEY = 'workOrderDocuments.status.label';
export const DOCUMENT_PROCESS_STATUS_NOT_SET_LABEL_KEY = 'workOrderDocuments.status.notSetLabel';

// Matches DocumentStatusDto.name as returned by the backend - used to fill in `name` for the
// optimistic local update, and as the dialog options' primary (untranslated) text.
export const DOCUMENT_PROCESS_STATUS_NAMES: Record<number, string> = {
  [DocumentProcessStatusCode.RedlineMarkup]: 'Redline Markup',
  [DocumentProcessStatusCode.ForInfo]: 'For Info',
  [DocumentProcessStatusCode.NoChange]: 'No Change',
};
